import React from 'react';
import { Form, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { Box, Button, Input, Stack } from '@/components';
import { useInputAttributes, useTranslation } from '@/hooks';
import { numberValidator, yupValidator } from '@/utils';

type ReferralCodeFormData = {
  user_id: string;
};
type ReferralCodeFormProps = {
  onNext: (data: ReferralCodeFormData) => void;
  getInquiriesLoading: boolean;
};

const ReferralCodeForm: React.FC<ReferralCodeFormProps> = ({
  onNext,
  getInquiriesLoading,
}) => {
  const { t } = useTranslation('pages.signUp.form.referralForm.codeForm');

  const validationSchema = yupValidator.object().shape({
    user_id: numberValidator({ label: t('user_id') })
      .min(2, t('minLength'))
      .max(7, t('maxLength')),
  });

  const {
    handleSubmit,
    control,
    register,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const filedInputProps = useInputAttributes<ReferralCodeFormData>(
    control,
    register,
    errors,
    {
      user_id: '',
    }
  );

  const onSubmit = (data: ReferralCodeFormData) => {
    onNext(data);
  };

  return (
    <Box display="flex" flexDirection="column" w="100%" h="100%" flexGrow={1}>
      <Form
        control={control}
        style={{
          width: '100%',
          flexGrow: 1,
          gap: 16,
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
        }}
      >
        <Box display="flex" flexDirection="column" height="100%" flexGrow={1}>
          <Stack flexGrow={1}>
            <Input type="tell" {...filedInputProps.user_id} />
          </Stack>
          <Stack w="100%" align="flex-end" sx={{ marginTop: 4 }}>
            <Button
              w="full"
              type="submit"
              onClick={(data) => void handleSubmit(onSubmit)(data)}
              isLoading={getInquiriesLoading}
            >
              {t('check')}
            </Button>
          </Stack>
        </Box>
      </Form>
    </Box>
  );
};
export default ReferralCodeForm;
